/* istanbul ignore file */
import React from 'react';
import { EnumDropdown, EnumDropdownProps } from 'framework/form';

export const EMPLOYEE_TIMELINE_RECORDS_ALIAS = {
  FEEDBACK_CREATED: 'FEEDBACK_CREATED',
  NOTE_CREATED: 'NOTE_CREATED',
  HEALTHCHECK_CREATED: 'HEALTHCHECK_CREATED',
};

const employeeTimelineRecords = {
  FEEDBACK_CREATED: 'Feedback',
  NOTE_CREATED: 'Note',
};

const EmployeeTimelineRecordTypeDropdown = (props: Omit<EnumDropdownProps, 'options'>) => {
  return <EnumDropdown {...props} options={employeeTimelineRecords} />;
};

export default EmployeeTimelineRecordTypeDropdown;
